import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ContentContainer } from "components/ContentContainer";
import Carousel from "react-material-ui-carousel";
import { theme } from "theme";

export function Content4() {
  return (
    <ContentContainer backgroundColor="primary">
      <Gallery />
    </ContentContainer>
  );
}

const IMGS = ["1", "2", "3"].map((num) => `images/img${num}.JPG`);

function Gallery() {
  return (
    <>
      <Typography variant="h2" fontWeight={"medium"}>
        Galeria
      </Typography>
      <Images />
    </>
  );
}

function Images() {
  return (
    <Carousel autoPlay={false} navButtonsAlwaysVisible indicators={false}>
      {IMGS.map((imgSrc) => (
        <Image key={imgSrc} imgSrc={imgSrc} />
      ))}
    </Carousel>
  );
}

function Image({ imgSrc, alt }: { imgSrc: string; alt: string }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 600,
        [theme.breakpoints.down("sm")]: { height: 300 },
      }}
    >
      <img
        src={imgSrc}
        alt={alt}
        style={{
          width: "auto",
          maxWidth: "100%",
          maxHeight: "100%",
          height: "auto",
        }}
      />
    </Box>
  );
}
Image.defaultProps = { alt: "" };
